var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M18.635 0H6.365C4.6769 0 3.05793 0.670596 1.86427 1.86427C0.670596 3.05793 0 4.6769 0 6.365L0 18.635C0 20.3231 0.670596 21.9421 1.86427 23.1357C3.05793 24.3294 4.6769 25 6.365 25H13.365V15.3325H10.0988V11.5588H13.3588V8.775C13.3588 5.545 15.3275 3.78875 18.2087 3.78875C19.1827 3.78398 20.1563 3.83239 21.125 3.93375V7.32H19.125C17.5537 7.32 17.25 8.0575 17.25 9.15375V11.5588H20.985L20.5 15.3325H17.25V25H18.6362C20.3241 24.9997 21.9428 24.3289 23.1362 23.1353C24.3296 21.9417 25 20.3229 25 18.635V6.365C25 4.6769 24.3294 3.05793 23.1357 1.86427C21.9421 0.670596 20.3231 0 18.635 0V0Z","fill":"white"}));
}

Facebook.defaultProps = {"width":"25","height":"25","viewBox":"0 0 25 25","fill":"none"};

module.exports = Facebook;

Facebook.default = Facebook;
